var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex justify-content-center" }, [
    _c("div", [
      _c(
        "form",
        {
          ref: "form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.saveUser.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Номер карты")]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.card.number,
                    expression: "card.number",
                  },
                ],
                staticClass: "form-control",
                attrs: { required: "", type: "text" },
                domProps: { value: _vm.card.number },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.card, "number", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.card.type,
                        expression: "card.type",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.card,
                          "type",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [_vm._v("VISA")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [_vm._v("MASTER")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [_vm._v("МИР")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "5" } }, [_vm._v("QiWi")]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          +_vm.card.type === 5
            ? _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v("Пароль к кошельку")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.card.extra_options.password,
                      expression: "card.extra_options.password",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: _vm.card.extra_options.password },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.card.extra_options,
                        "password",
                        $event.target.value
                      )
                    },
                  },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Комментарий к счету")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.card.extra_options.comment,
                  expression: "card.extra_options.comment",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.card.extra_options.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.card.extra_options,
                    "comment",
                    $event.target.value
                  )
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Статус аккаунта")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.card.extra_options.status,
                    expression: "card.extra_options.status",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.card.extra_options,
                      "status",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c("option", { attrs: { value: "regular" } }, [
                  _vm._v("Основной"),
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "professional" } }, [
                  _vm._v("Професиональный"),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Назначение карты")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.card.use_type_id,
                    expression: "card.use_type_id",
                  },
                ],
                staticClass: "form-control",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.card,
                      "use_type_id",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              _vm._l(_vm.useTypes, function (t) {
                return _c("option", { domProps: { value: t.id } }, [
                  _vm._v(_vm._s(t.title)),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Владелец карты")]),
            _vm._v(" "),
            false
              ? _c("div", [
                  _c("label", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.isNew,
                          expression: "user.isNew",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.user.isNew)
                          ? _vm._i(_vm.user.isNew, null) > -1
                          : _vm.user.isNew,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.user.isNew,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.user, "isNew", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.user,
                                  "isNew",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.user, "isNew", $$c)
                          }
                        },
                      },
                    }),
                    _vm._v(" Новый владелец"),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.user.isNew
            ? [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Фамилия Инициалы")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.short_name,
                        expression: "user.short_name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { required: "", type: "text" },
                    domProps: { value: _vm.user.short_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "short_name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("ФИО")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.full_name,
                        expression: "user.full_name",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.full_name },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "full_name", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Bank login")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.banking_login,
                        expression: "user.banking_login",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.banking_login },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.user, "banking_login", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", [_vm._v("Bank password")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.banking_password,
                        expression: "user.banking_password",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.banking_password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.user,
                          "banking_password",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]
            : [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.id,
                          expression: "user.id",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.user,
                            "id",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "0" } }, [
                        _vm._v("Выберите владельца"),
                      ]),
                    ]
                  ),
                ]),
              ],
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Комментарий")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.options.comment,
                  expression: "user.options.comment",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.user.options.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.user.options, "comment", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          !_vm.user.id
            ? _c("div", { staticClass: "alert alert-info" }, [
                _c("p", [
                  _vm._v("Добавление файлов возможно, после сохранения карты"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { ref: "submit", staticClass: "hidden", attrs: { type: "submit" } },
            [_vm._v("submit")]
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-2" }, [
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Proxy адрес")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.card.extra_options.proxy.address,
              expression: "card.extra_options.proxy.address",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.card.extra_options.proxy.address },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.card.extra_options.proxy,
                "address",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Proxy порт")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.card.extra_options.proxy.port,
              expression: "card.extra_options.proxy.port",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.card.extra_options.proxy.port },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.card.extra_options.proxy,
                "port",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Proxy логин")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.card.extra_options.proxy.user,
              expression: "card.extra_options.proxy.user",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.card.extra_options.proxy.user },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.card.extra_options.proxy,
                "user",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", [_vm._v("Proxy пароль")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.card.extra_options.proxy.pass,
              expression: "card.extra_options.proxy.pass",
            },
          ],
          staticClass: "form-control",
          attrs: { type: "text" },
          domProps: { value: _vm.card.extra_options.proxy.pass },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.$set(
                _vm.card.extra_options.proxy,
                "pass",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.card.id
        ? _c(
            "div",
            [
              _c("UploadCustomWithPreview", {
                attrs: {
                  allowToUpload: true,
                  extraData: { object: "credit_card", objectId: _vm.card.id },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }